<template>
  <SogCard class="sog-card-without-title">
    <SogCardContent>
      <SogFlexColumn>
        <SogButton
          v-show="currentProductTypes.kzk"
          style="height: 80px; padding: 10px"
          class="full-width"
          @click="onSelectProductType(ProductType.Kzk)"
        >
          Kurzzeitkennzeichen
        </SogButton>
        <SogButton
          v-show="currentProductTypes.zoll"
          style="height: 80px"
          class="full-width"
          @click="onSelectProductType(ProductType.Zoll)"
        >
          Ausfuhrkennzeichen
        </SogButton>
        <SogButton
          v-show="currentProductTypes.tz"
          style="height: 80px"
          class="full-width"
          @click="onSelectProductType(ProductType.Tz)"
        >
          Tageszulassung
        </SogButton>
        <SogButton
          v-show="currentProductTypes.exportBlank"
          style="height: 80px"
          class="full-width"
          @click="onSelectProductType(ProductType.ExportBlank)"
        >
          Ausfuhrversicherungsformulare
        </SogButton>
      </SogFlexColumn>
    </SogCardContent>
  </SogCard>
</template>

<script setup lang="ts">

import {ProductType} from "@/shared/model/productType";
import SogButton from "@/shared/ui/SogButton.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import {storeToRefs} from "pinia";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {useRouter} from "vue-router";

const _shoppingCartStore = useShoppingCartStore();
const _router = useRouter();

const {currentProductTypes} = storeToRefs(_shoppingCartStore);


async function onSelectProductType(value: ProductType) {
  await _shoppingCartStore.setProductType(value);
  if (value === ProductType.ExportBlank) {
    await _router.push({path: "productprice"});
  } else {
    await _router.push({path: "product"});
  }
}

</script>

<style scoped>

</style>
